import { axios } from "../connection/ConnectionHandler";
import { API } from "../constants/api";
import { keyBy } from "lodash";
import {
    ADD_NEW_APPLICATION,
    DELETE_APPLICATION,
    APPLICATION_FORM_TOOGLE_LOADING,
    SET_APPLICATION_LIST,
    SHOW_NOTIFICATION,
    UPDATE_APPLICATION,
} from "../constants";
import { formatApplications } from "./settingsActionsUtils";

/* APPLICATION LIST */
export const fetchApplications = () => {
    return async (dispatch) => {
        const response = await axios
            .get(API.applications.list)
            .then((response) => {
                const applications = formatApplications(response.data);
                dispatch({
                    type: SET_APPLICATION_LIST,
                    payload: keyBy(applications, "_id"),
                });
                return response.status;
            })
            .catch((err) => err);
        return response;
    };
};

// APPLICATIONS
export const createApplication = (newApplication) => {
    return async (dispatch) => {
        dispatch({ type: APPLICATION_FORM_TOOGLE_LOADING });
        const response = await axios
            .post(API.applications.create, newApplication)
            .then((response) => {
                const application = formatApplications(response.data);
                dispatch({ type: ADD_NEW_APPLICATION, payload: application });
                dispatch({ type: APPLICATION_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "success",
                        message: "Aplicación creado con éxito.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: APPLICATION_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const updateApplication = (updatedApplication) => {
    return async (dispatch) => {
        dispatch({ type: APPLICATION_FORM_TOOGLE_LOADING });
        const response = await axios
            .put(`${API.applications.edit}${updatedApplication && updatedApplication._id}`, updatedApplication)
            .then((response) => {
                const application = formatApplications(response.data);
                dispatch({ type: UPDATE_APPLICATION, payload: application });
                dispatch({ type: APPLICATION_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "info",
                        message: "Aplicación actualizado.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: APPLICATION_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const deleteApplications = (Ids) => {
    return async (dispatch) => {
        dispatch({ type: APPLICATION_FORM_TOOGLE_LOADING });
        const response = await axios
            .delete(`${API.applications.delete}`, { data: Ids })
            .then((response) => {
                dispatch({ type: DELETE_APPLICATION, payload: Ids });
                dispatch({ type: APPLICATION_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "info",
                        message: "Aplicación eliminado.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: APPLICATION_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};
